export const DEFAULT_TEMPLATES = [
    {
        nome: "Modelo padrão #01",
        assunto: "Bem-vindo(a) ao evento!",
        fromName: "Equipe do Evento",
        replyTo: "aplicacao@r1eventech.com.br",
        html: `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">

<head>
  <title></title>a
  <meta charset="UTF-8" />
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <!--[if !mso]>-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <!--<![endif]-->
  <meta name="x-apple-disable-message-reformatting" content="" />
  <meta content="target-densitydpi=device-dpi" name="viewport" />
  <meta content="true" name="HandheldFriendly" />
  <meta content="width=device-width" name="viewport" />
  <meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no" />
  <style type="text/css">
    table {border-collapse: separate;table-layout: fixed;mso-table-lspace: 0pt;mso-table-rspace: 0pt}
    table td {border-collapse: collapse}
    .ExternalClass {width: 100%}
    .ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div {line-height: 100%}
    body, a, li, p, h1, h2, h3 {-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;}
    html {-webkit-text-size-adjust: none !important}
    body {min-width: 100%;Margin: 0px;padding: 0px;}
    body, #innerTable {-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale}
    #innerTable img+div {display: none;display: none !important}
    img {Margin: 0;padding: 0;-ms-interpolation-mode: bicubic}
    h1, h2, h3, p, a {overflow-wrap: normal;white-space: normal;word-break: break-word}
    a {text-decoration: none}
    h1, h2, h3, p {min-width: 100%!important;width: 100%!important;max-width: 100%!important;display: inline-block!important;border: 0;padding: 0;margin: 0}
    a[x-apple-data-detectors] {color: inherit !important;text-decoration: none !important;font-size: inherit !important;font-family: inherit !important;font-weight: inherit !important;line-height: inherit !important}
    u + #body a {color: inherit;text-decoration: none;font-size: inherit;font-family: inherit;font-weight: inherit;line-height: inherit;}
    a[href^="mailto"],a[href^="tel"],a[href^="sms"] {color: inherit;text-decoration: none}
  </style>
  <style type="text/css">
    @media (min-width: 481px) {.hd { display: none!important }}
  </style>
  <style type="text/css">
    @media (max-width: 480px) {.hm { display: none!important }}
  </style>
  <style type="text/css">
    @media (max-width: 480px) {.t29,.t34{mso-line-height-alt:0px!important;line-height:0!important;display:none!important}.t30{padding-top:43px!important;border:0!important;border-radius:0!important}.t24{mso-line-height-alt:26px!important;line-height:26px!important}}
  </style>
  <!--[if !mso]>-->
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@500;700&amp;family=Albert+Sans:wght@500&amp;display=swap" rel="stylesheet" type="text/css" />
  <!--<![endif]-->
</head>

<body id="body" class="t37" style="min-width:100%;Margin:0px;padding:0px;background-color:#F9F9F9;">
  <div class="t36" style="background-color:#F9F9F9;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" align="center">
      <tr>
        <td class="t35" style="font-size:0;line-height:0;mso-line-height-rule:exactly;background-color:#F9F9F9;" valign="top" align="center">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" align="center" id="innerTable">
            <tr>
              <td>
                <div class="t29" style="mso-line-height-rule:exactly;mso-line-height-alt:70px;line-height:70px;font-size:1px;display:block;">&nbsp;&nbsp;</div>
              </td>
            </tr>
            <tr>
              <td align="center">
                <table class="t33" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;">
                  <tr>
                    <td width="400" class="t32" style="width:400px;">
                      <table class="t31" cellpadding="0" cellspacing="0" width="100%" style="width:100%;">
                        <tr>
                          <td class="t30" style="border:1px solid #CECECE;overflow:hidden;background-color:#FFFFFF;padding:50px 40px 40px 40px;border-radius:20px 20px 20px 20px;">
                            <table width="100%" cellpadding="0" cellspacing="0" style="width:100% !important;">
                              <tr>
                                <td align="center">
                                  <table class="t4" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;">
                                    <tr>
                                      <td width="200" class="t3" style="width:250px;">
                                        <table class="t2" cellpadding="0" cellspacing="0" width="100%" style="width:100%;">
                                          <tr>
                                            <td class="t1"><a href="#" style="font-size:0px;" target="_blank"><img class="t0" style="display:block;border:0;height:125px;Margin:auto;" alt="" src="https://images.r1eventech.com.br/r1/logo.png" /></a></td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="t6" style="mso-line-height-rule:exactly;mso-line-height-alt:17px;line-height:17px;font-size:1px;display:block;">&nbsp;&nbsp;</div>
                                </td>
                              </tr>
                              <tr>
                                <td align="center">
                                  <table class="t10" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;">
                                    <tr>
                                      <td width="308" class="t9" style="width:308px;">
                                        <table class="t8" cellpadding="0" cellspacing="0" width="100%" style="width:100%;">
                                          <tr>
                                            <td class="t7">
                                              <p class="t5" style="margin:0;Margin:0;font-family:Inter,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-style:normal;font-size:15px;text-decoration:none;text-transform:none;letter-spacing:-0.6px;direction:ltr;color:#424040;text-align:center;mso-line-height-rule:exactly;mso-text-raise:2px;">Sua inscrição foi confirmada! Obrigado por se registrar em nosso evento.</p>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                              <tr>
                                <td>
                                  <div class="t24" style="mso-line-height-rule:exactly;mso-line-height-alt:30px;line-height:30px;font-size:1px;display:block;">&nbsp;&nbsp;</div>
                                </td>
                              </tr>
                              <tr>
                                <td align="center">
                                  <table class="t28" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;">
                                    <tr>
                                      <td width="318" class="t27" style="width:420px;">
                                        <table class="t26" cellpadding="0" cellspacing="0" width="100%" style="width:100%;">
                                          <tr>
                                            <td class="t25" style="overflow:hidden;background-color:#F2EFF3;padding:20px 30px 20px 30px;border-radius:8px 8px 8px 8px;">
                                              <p class="t23" style="margin:0;Margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:18px;font-weight:500;font-style:normal;font-size:12px;text-decoration:none;text-transform:none;direction:ltr;color:#84828E;text-align:center;mso-line-height-rule:exactly;mso-text-raise:2px;">{{event_name}}</p>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="t18" style="mso-line-height-rule:exactly;mso-line-height-alt:40px;line-height:40px;font-size:1px;display:block;">
                                    &nbsp;&nbsp;</div>
                                </td>
                              </tr>
                              <tr>
                                <td align="center">
                                  <table class="t22" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;">
                                    <tr>
                                      <td width="318" class="t21" style="width:318px;">
                                        <table class="t20" cellpadding="0" cellspacing="0" width="100%" style="width:100%;">
                                          <tr>
                                            <td class="t19">
                                              <p class="t17" style="margin:0;Margin:0;font-family:Inter,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-style:normal;font-size:14px;text-decoration:none;text-transform:none;letter-spacing:-0.6px;direction:ltr;color:#424040;text-align:center;mso-line-height-rule:exactly;mso-text-raise:2px;">
                                                Em caso de duvidas, entre em contato com a organização do evento.</p>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <div class="t34" style="mso-line-height-rule:exactly;mso-line-height-alt:70px;line-height:70px;font-size:1px;display:block;">&nbsp;&nbsp;</div>
        </td>
      </tr>
    </table>
    </td>
    </tr>
    </table>
  </div>
</body>

</html>`,
    }
];
